import log from 'loglevel';

import { TriMeshGrid2 } from '../geometry/triMeshGrid2';

export class PieceGeometryCache {
  grid: TriMeshGrid2 | null;

  private indicesRef: Uint32Array | null;
  private verticesRef: Float32Array | null;

  constructor() {
    this.grid = null;
    this.indicesRef = null;
    this.verticesRef = null;
  }

  dispose() {
    if (this.grid) {
      this.grid.dispose();
    }
    // clear refs
    this.indicesRef = null;
    this.verticesRef = null;
  }

  updateGrid(indices: Uint32Array, vertices: Float32Array, cellSize: number) {
    // same ref object comparison (shallow).
    if (this.indicesRef === indices && this.verticesRef === vertices) {
      return;
    }

    // free previous grid if available
    if (this.grid) {
      this.dispose();
    }

    // create grid
    log.log(`Piece grid construction`);
    this.grid = new TriMeshGrid2();
    this.grid.init(indices, vertices, cellSize);

    // save refs
    this.indicesRef = indices;
    this.verticesRef = vertices;
  }
}
